import { render, staticRenderFns } from "./DatabasesDialog.vue?vue&type=template&id=6ed7971c&scoped=true&"
import script from "./DatabasesDialog.vue?vue&type=script&lang=js&"
export * from "./DatabasesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7971c",
  null
  
)

export default component.exports